<template>
  <div class="container bg-transparent">
    <div class="row">
      <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
        <div class="card card-signin my-5 shadow border-0">
          <div class="card-body border-0">
            <h5 class="card-title text-center">Demande d'authentification</h5>
            <div v-if="waiting" class="text-center">
              <div class="text-center">
                <i>En cours de traitement, patientez SVP...</i>
              </div>
              <div class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
            <form class="mx-4 form-signin" v-if="!waiting" @submit="formSubmit($event)">
              <div class="row mb-3">
                <label for="inputEmail">Identifiant</label>
                <input
                  v-model="fields.username"
                  type="text"
                  id="inputEmail"
                  class="form-control"
                  placeholder="Identifiant"
                  required
                  autofocus
                />
              </div>
              <div class="row mb-3">
                <label for="inputPassword">Mot de passe</label>
                <input
                  v-model="fields.password"
                  type="password"
                  id="inputPassword"
                  class="form-control"
                  placeholder="Mot de passe"
                  required
                />
              </div>
              <div class="row mt-4">
                <button
                  class="btn btn-lg btn-primary btn-block text-uppercase"
                  type="submit"
                >Se connecter</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      waiting: false,
      fields: {}
    };
  },
  methods: {
    clearFields() {
      this.fields = {
        username: "",
        password: ""
      };
    },
    async formSubmit(event) {
      event.preventDefault();
      event.stopPropagation();
      this.waiting = true;
      try {
        await this.login(this.fields);
        this.waiting = false;
        this.$router.push("/");
      } catch (e) {
        this.waiting = false;
        this.pushError(e);
      }
    }
  },
  mounted() {
    this.clearFields();
    if (this.isUserAuthenticated) {
      this.$router.replace({ name: "Accueil" });
    }
  }
};
</script>
